import {Component, Input, OnInit} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {OnboardingDto} from "../../types/ob.interfaces";
import {FormGroup} from "@angular/forms";
import {FieldAccess} from "../../../rg/types/registration.types";


@Component({
  selector: 'questionnaire',
  templateUrl: 'questionnaire.component.html',
})
export class QuestionnaireComponent extends CoreComponent implements OnInit {

  @Input() onboardingDto: OnboardingDto | undefined;
  @Input() questionerForm: FormGroup | undefined;


  protected readonly FieldAccess = FieldAccess;
}
